import { accountUrl } from '../lib/urls'

export const ErrorMessage = ({ error, accountId }) => {
  if (error?.status === 403 && accountId) {
    return (
      <div className="pds-p-md">
        <h4 className="pds-mb-xs">
          We’re having trouble accessing your Harvest account.
        </h4>
        <p>
          <a
            className="pds-link"
            href={accountUrl(accountId, '/')}
            target="_blank"
            rel="noreferrer"
          >
            Check your account
          </a>{' '}
          to learn more.
        </p>
      </div>
    )
  }
  return (
    <div className="pds-p-md">
      <h4 className="pds-mb-xs">
        We have experienced an error. Please reload the page.
      </h4>
      <p>
        If the problem persists, please check our{' '}
        <a
          href="https://www.harveststatus.com/"
          target="_blank"
          rel="noreferrer"
        >
          status page
        </a>{' '}
        or get in touch with{' '}
        <a
          href="https://www.getharvest.com/contact"
          target="_blank"
          rel="noreferrer"
        >
          support
        </a>
        .
      </p>
    </div>
  )
}
